export default __webpack_public_path__ + "static/media/image2pro2.b3ff10b7.jpeg";